// extracted by mini-css-extract-plugin
export var active = "_df-c";
export var compactArrow = "_df-5";
export var container = "_df-0";
export var dot = "_df-b";
export var dotContainer = "_df-a";
export var hoverArrowButton = "_df-7";
export var hoverArrowContainer = "_df-6";
export var leftHoverArrowContainer = "_df-8 _df-6";
export var rightHoverArrowContainer = "_df-9 _df-6";
export var slide = "_df-4";
export var sliderContainer = "_df-1";
export var sliderContainerVisibleOverflow = "_df-2";
export var sliderOverflow = "_df-3";
export var vignetteBoth = "_df-f";
export var vignetteLeft = "_df-e";
export var vignetteRight = "_df-d";